import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Col, RSelect } from "../../../components/Component";
import Head from "../../../layout/head/Head";
import { Form } from "reactstrap";
import { handleGetApis, handlePostApis } from "../../../service/Api";
import Content from "../../../layout/content/Content";
import { filterStatus } from "../../../service/Data";

const slugify = (text) =>
  text
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, "")   // remove special chars
    .replace(/[\s_]+/g, "-")    // spaces/underscores -> hyphen
    .replace(/--+/g, "-");       // multiple hyphens -> one

// 0 is a valid price/stock (e.g. sold out), so only truly empty values fail.
const isEmpty = (val) => val === undefined || val === null || String(val).trim() === "";

const AddProduct = () => {
  const navigate = useNavigate();
  const [categoryList, setCategoryData] = useState([]);
  const [errors, setErrors] = useState({});
  const [addData, setAddData] = useState({
    name: "",
    title: "",
    slug: "",
    short_description: "",
    description: "",
    category_id: "",
    meta_title: "",
    meta_description: "",
    meta_keywords: "",
    is_active: true,
    is_featured: false,
    is_cart: false,
    variants: [
      {
        size: "6ml",
        price: "",
        mrp: "",
        stock: "",
        sku: "",
        is_active: true
      },
    ],
  });

  const updateVariant = (index, field, value) =>
    setAddData((prev) => ({
      ...prev,
      variants: prev.variants.map((v, i) => (i === index ? { ...v, [field]: value } : v)),
    }));

  const validateForm = () => {
    let newErrors = {};

    // basic fields
    if (!addData.name.trim()) newErrors.name = "Name is required";
    if (!addData.title.trim()) newErrors.title = "Title is required";
    if (!addData.slug.trim()) newErrors.slug = "Slug is required";
    if (!addData.category_id) newErrors.category_id = "Category is required";

    // variants validation
    addData.variants.forEach((v, index) => {
      if (isEmpty(v.size)) newErrors[`variant_size_${index}`] = "Size required";
      if (isEmpty(v.price)) newErrors[`variant_price_${index}`] = "Price required";
      if (isEmpty(v.mrp)) newErrors[`variant_mrp_${index}`] = "Mrp required";
      if (isEmpty(v.stock)) newErrors[`variant_stock_${index}`] = "Stock required";
      if (isEmpty(v.sku)) newErrors[`variant_sku_${index}`] = "SKU required";
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const fetchCategory = async () => {
    try {
      const result = await handleGetApis("admin/get/categories");
      console.log(result);
      if (result) {
        const formatted = [];
        result.data.result.forEach((cat) =>{
          if(cat.is_active === 0) return;
          formatted.push({
            value: cat.id,
            label: cat.name,
          })
        });
        setCategoryData(formatted);
      }
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    fetchCategory();
  }, []);
  const postProduct = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const payload = {
      name:              addData.name,
      title:             addData.title,
      slug:              addData.slug,
      short_description: addData.short_description,
      description:       addData.description,
      category_id:       addData.category_id,
      meta_title:        addData.meta_title,
      meta_description:  addData.meta_description,
      meta_keywords:     addData.meta_keywords,
      is_active:         addData.is_active ? 1 : 0,
      is_featured:       addData.is_featured ? 1 : 0,
      is_cart:           addData.is_cart ? 1 : 0,
      variants:          JSON.stringify(addData.variants),
    };

    try {
      const res = await handlePostApis("admin/add/product", payload);

      if (res?.data?.success) {
        alert("Product added successfully! You can now manage its media from the Product List.");
        navigate("/product-list");
      } else {
        alert(res?.data?.message || "Something went wrong");
      }
    } catch (err) {
      console.error(err);
      alert("Server error");
    }
  };
  return (
    <>
      <Head title="Add Product" />
      <Content>
        <div className="p-2">
          <h5 className="title">Add Product</h5>

          <Form className="row gy-4 mt-3">
            <Col md="6">
              <label className="form-label">Name</label>
              <input
                className={`form-control ${errors.name ? "is-invalid" : ""}`}
                value={addData.name}
                onChange={(e) => {
                  const name = e.target.value;
                  setAddData({ ...addData, name, slug: slugify(name) });
                }}
              />
              {errors.name && <div className="invalid-feedback">{errors.name}</div>}
            </Col>
            <Col md="6">
              <label className="form-label">Title</label>
              <input
                className={`form-control ${errors.title ? "is-invalid" : ""}`}
                value={addData.title}
                onChange={(e) => setAddData({ ...addData, title: e.target.value })}
              />
              {errors.title && <div className="invalid-feedback">{errors.title}</div>}
            </Col>

            <Col md="6">
              <label className="form-label">Slug</label>
              <input
                className={`form-control ${errors.slug ? "is-invalid" : ""}`}
                value={addData.slug}
                onChange={(e) => setAddData({ ...addData, slug: e.target.value })}
              />
              {errors.slug && <div className="invalid-feedback">{errors.slug}</div>}
            </Col>

            <Col md="6">
              <label className="form-label">Category</label>
              <RSelect
                options={categoryList}
                value={categoryList.find((c) => c.value === addData.category_id)}
                onChange={(e) => setAddData({ ...addData, category_id: e.value })}
              />
              {errors.category_id && <div className="text-danger small mt-1">{errors.category_id}</div>}
            </Col>

            <Col md="12">
              <label className="form-label">Short Description</label>
              <textarea
                className="form-control"
                value={addData.short_description}
                onChange={(e) =>
                  setAddData({
                    ...addData,
                    short_description: e.target.value,
                  })
                }
              />
            </Col>

            <Col md="12">
              <label className="form-label">Description</label>
              <textarea
                className="form-control"
                value={addData.description}
                onChange={(e) => setAddData({ ...addData, description: e.target.value })}
              />
            </Col>

            {/* ── SEO / Meta Fields ── */}
            <Col md="6">
              <label className="form-label">Meta Title</label>
              <input
                className="form-control"
                placeholder="Meta title for SEO"
                value={addData.meta_title}
                onChange={(e) => setAddData({ ...addData, meta_title: e.target.value })}
              />
            </Col>

            <Col md="6">
              <label className="form-label">Meta Keywords</label>
              <input
                className="form-control"
                placeholder="Keywords separated by comma"
                value={addData.meta_keywords}
                onChange={(e) => setAddData({ ...addData, meta_keywords: e.target.value })}
              />
            </Col>

            <Col md="12">
              <label className="form-label">Meta Description</label>
              <textarea
                className="form-control"
                rows={2}
                placeholder="Meta description for search engines..."
                value={addData.meta_description}
                onChange={(e) => setAddData({ ...addData, meta_description: e.target.value })}
              />
            </Col>

            {/* Variant */}
            {addData.variants.map((v, index) => (
              <div key={index} className="row mt-4 mb-2">
                <Col md="3">
                  <input
                    placeholder="Size"
                    className="form-control"
                    value={v.size}
                    onChange={(e) => {
                      updateVariant(index, "size", e.target.value);
                    }}
                  />
                  {errors[`variant_size_${index}`] && (
                    <small className="text-danger">{errors[`variant_size_${index}`]}</small>
                  )}
                </Col>

<Col md="3">
                  <input
                    placeholder="MRP"
                    className="form-control"
                    value={v.mrp}
                    onChange={(e) => {
                      updateVariant(index, "mrp", e.target.value);
                    }}
                  />
                  {errors[`variant_mrp_${index}`] && (
                    <small className="text-danger">{errors[`variant_mrp_${index}`]}</small>
                  )}
                </Col>
                <Col md="3">
                  <input
                    placeholder="Price"
                    className="form-control"
                    value={v.price}
                    onChange={(e) => {
                      updateVariant(index, "price", e.target.value);
                    }}
                  />
                  {errors[`variant_price_${index}`] && (
                    <small className="text-danger">{errors[`variant_price_${index}`]}</small>
                  )}
                </Col>

                <Col md="3">
                  <input
                    placeholder="Stock"
                    className="form-control"
                    value={v.stock}
                    onChange={(e) => {
                      updateVariant(index, "stock", e.target.value);
                    }}
                  />
                  {errors[`variant_stock_${index}`] && (
                    <small className="text-danger">{errors[`variant_stock_${index}`]}</small>
                  )}
                </Col>
                <Col md="3">
                  <input
                    placeholder="SKU"
                    className="form-control"
                    value={v.sku}
                    onChange={(e) => {
                      updateVariant(index, "sku", e.target.value);
                    }}
                  />
                  {errors[`variant_sku_${index}`] && (
                    <small className="text-danger">{errors[`variant_sku_${index}`]}</small>
                  )}
                </Col>
                <Col md="3">
                  <RSelect
                options={filterStatus}
                value={{ 
                  value: v.is_active,
                  label: v.is_active ? "Active" : "Not Active",
                }}
                onChange={(e) => {
                      updateVariant(index, "is_active", e.value);
                    }}
              />
                </Col>

                <Col md="3">
                  <Button
                    type="button"
                    color="danger"
                    onClick={() => {
                      if (addData.variants.length === 1) return;
                      const variants = addData.variants.filter((_, i) => i !== index);
                      setAddData({ ...addData, variants });
                    }}
                  >
                    Remove
                  </Button>
                </Col>
              </div>
            ))}
            <Col className="mb-4">
              <Button
                color="primary"
                type="button"
                onClick={() =>
                  setAddData({
                    ...addData,
                    variants: [...addData.variants, { size: "", mrp: "", price: "", stock: "", sku: "", is_active: true }],
                  })
                }
              >
                + Add Variant
              </Button>
            </Col>

            <Col md="3">
              <label className="form-label">Feature Product</label>
              <RSelect
                options={filterStatus}
                value={{
                  value: addData.is_featured,
                  label: addData.is_featured ? "Active" : "Not Active",
                }}
                onChange={(e) => setAddData({ ...addData, is_featured: e.value })}
              />
            </Col>
            <Col md="3">
              <label className="form-label">Cart Product</label>
              <RSelect
                options={filterStatus}
                value={{
                  value: addData.is_cart,
                  label: addData.is_cart ? "Active" : "Not Active",
                }}
                onChange={(e) => setAddData({ ...addData, is_cart: e.value })}
              />
            </Col>
            <Col md="6">
              <label className="form-label">Status</label>
              <RSelect
                options={filterStatus}
                value={{
                  value: addData.is_active,
                  label: addData.is_active ? "Active" : "Not Active",
                }}
                onChange={(e) => setAddData({ ...addData, is_active: e.value })}
              />
            </Col>

            <Col md="12">
              <Button type="submit" color="primary" onClick={postProduct}>
                Submit
              </Button>
            </Col>
          </Form>
        </div>
      </Content>
    </>
  );
};

export default AddProduct;
